import React from "react";
import { Switch, Route } from "react-router-dom";

import List from './List';
import Form from './Form';

const Events = () =>
    (
        <Switch>
            <Route path='/events/create' component={Form} />
            <Route path='/events/:id/edit' exact component={Form} />
            <Route path='/events' component={List} />
        </Switch>
    );


export default Events;